import React from 'react';
import { CronTemplates } from '../components';

export const Page: React.FC = () => <CronTemplates />;
